var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search",
    d: "M1329.236,744.48a7.48,7.48,0,1,1-10.578,0A7.479,7.479,0,0,1,1329.236,744.48Zm2.508,11.38a9.893,9.893,0,1,0-1.706,1.706l5.17,5.17a.483.483,0,0,0,.683,0l1.024-1.024a.483.483,0,0,0,0-.683Z",
    transform: "translate(-1314.055 -739.876)",
    fill: "#2f2f35",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5cbba14b57a094fc4d21be53beb1eb7a.svg";
export { ForwardRef as ReactComponent };